import { render, staticRenderFns } from "./bodyPreviewCastingCall.vue?vue&type=template&id=0aa10499&scoped=true&"
import script from "./bodyPreviewCastingCall.vue?vue&type=script&lang=js&"
export * from "./bodyPreviewCastingCall.vue?vue&type=script&lang=js&"
import style0 from "./bodyPreviewCastingCall.vue?vue&type=style&index=0&id=0aa10499&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa10499",
  null
  
)

export default component.exports